import { render, staticRenderFns } from "./ReservationNotes.vue?vue&type=template&id=034a661e"
import script from "./ReservationNotes.vue?vue&type=script&lang=js"
export * from "./ReservationNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports